// Google Analytics ve Search Console entegrasyon dosyası
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-XXXXXXXXXX';
export const ANALYTICS_CONSENT_KEY = 'pine_analytics_consent';
export const OPEN_ANALYTICS_CONSENT_EVENT = 'pine:open-cookie-consent';

const isClient = () => typeof window !== 'undefined' && typeof document !== 'undefined';
const hasValidTrackingId = () => !!GA_TRACKING_ID && !GA_TRACKING_ID.includes('XXXXXXXXXX');
const isProductionDeploy = () => (
  process.env.NODE_ENV === 'production'
  && ['production', 'release'].includes(process.env.REACT_APP_DEPLOY_ENV)
);

const isAnalyticsRuntimeEnabled = () => (
  isClient()
  && isProductionDeploy()
  && hasValidTrackingId()
  && hasAnalyticsConsent()
  && !!window.__pineGaInitialized
);

export const getAnalyticsConsentStatus = () => {
  if (!isClient()) return 'unknown';
  return localStorage.getItem(ANALYTICS_CONSENT_KEY) || 'unknown';
};

export const hasAnalyticsConsent = () => getAnalyticsConsentStatus() === 'granted';

export const setAnalyticsConsent = (status) => {
  if (!isClient()) return;

  const consentStatus = status === 'granted' ? 'granted' : 'denied';
  localStorage.setItem(ANALYTICS_CONSENT_KEY, consentStatus);

  if (window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: consentStatus,
    });
  }
};

export const openAnalyticsConsentPreferences = () => {
  if (!isClient()) return;
  window.dispatchEvent(new CustomEvent(OPEN_ANALYTICS_CONSENT_EVENT));
};

// Google Analytics initialization
export const initGA = () => {
  if (!isClient() || !isProductionDeploy() || !hasValidTrackingId() || !hasAnalyticsConsent()) {
    return false;
  }

  if (window.__pineGaInitialized) {
    return true;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };

  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script1);

  window.gtag('consent', 'default', {
    analytics_storage: 'granted',
  });

  window.gtag('js', new Date());
  window.gtag('config', GA_TRACKING_ID, {
    send_page_view: false,
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure'
  });

  window.__pineGaInitialized = true;
  return true;
};

// Track page views
export const trackPageView = (url, title) => {
  if (isAnalyticsRuntimeEnabled() && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: title,
      page_location: url,
    });
  }
};

// Track events
export const trackEvent = (action, categoryOrParams = 'General', label = '', value = 0) => {
  if (isAnalyticsRuntimeEnabled() && window.gtag) {
    if (typeof categoryOrParams === 'object' && categoryOrParams !== null) {
      window.gtag('event', action, categoryOrParams);
      return;
    }

    const eventPayload = {
      event_category: categoryOrParams,
      event_label: label,
    };

    if (Number.isFinite(value) && value !== 0) {
      eventPayload.value = value;
    }

    window.gtag('event', action, eventPayload);
  }
};

// Özel SEO event'leri
export const trackBusinessClick = (businessName, businessId) => {
  trackEvent('business_click', 'Business', businessName, businessId);
};

export const trackAppointmentStart = (businessName) => {
  trackEvent('appointment_start', 'Appointment', businessName);
};

export const trackAppointmentComplete = (businessName) => {
  trackEvent('appointment_complete', 'Appointment', businessName);
};

export const trackSearchQuery = (query) => {
  trackEvent('search', 'Search', query);
};

// Search Console verification
export const addSearchConsoleVerification = (verificationCode) => {
  if (typeof document !== 'undefined') {
    const meta = document.createElement('meta');
    meta.name = 'google-site-verification';
    meta.content = verificationCode;
    document.head.appendChild(meta);
  }
};
